<template>
    <div class="zsxx_h5">
      <TopTabs :list="this.$nav10"/>
      <div class="zsxx_bottom">
          <div class="zsxx_content" v-for="(item, index) in list" :key="index">
            <div class="zsxx_content_box" @click="toPage(item)">
              <div class="zsxx_content_yuan"></div>
              <div class="zsxx_content_text">{{item.title}}</div>
            </div>
            <div class="zsxx_content_time">{{item.create_time}}</div>
          </div>
      </div>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'

export default {
  name: 'Dtxx',
  components: { TopTabs },
  props: {},
  data () {
    return {
      list: []
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getList()
  },
  mounted () {},
  methods: {
    async getList () {
      const { data } = await this.$get('/ow/article', { column_id: 7 })
      this.list = data
    },
    toPage (item) {
      console.log(item)
      if (item.is_jump === 0) {
        this.$router.push({
          path: '/article',
          query: { id: item.id }
        })
      } else {
        window.open(item.jump_url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .zsxx_h5 {
    width: 100vw;
    font-size: 3.7333vw;
    color: #333333;
    min-height: 200vw;
    .zsxx_bottom {
       padding: 0 4.2667vw;
     }
      .zsxx_content {
       display: flex;
       justify-content: space-between;
       border-bottom: 1px dashed #DBDBDB;
       margin-bottom: 3.2vw;
        .zsxx_content_box {
          display: flex;

         .zsxx_content_yuan {
            width: 1.0667vw;
            height: 1.0667vw;
            background: #E88E0D;
            border-radius: 50%;
            margin-top: 2.1333vw;
            margin-right: 1.6vw;
          }
         .zsxx_content_text {
            padding-bottom: 8px;
            cursor: pointer;
            width: 64.6667vw;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .zsxx_content_time{
          color: #999999;
        }
      }
    }
</style>
